var $export = require('./_export');
var $task = require('./_task');
$export($export.G + $export.B, {
  setImmediate: $task.set,
  clearImmediate: $task.clear
});



//////////////////
// WEBPACK FOOTER
// ./apps/guias/~/core-js/modules/web.immediate.js
// module id = 327
// module chunks = 0